import { Observable } from 'rxjs';
import httpService from './httpService';
import { TripLegPackage } from '../data/models/trip-leg.model';
import {
  type TripLegStatusBC,
  TripLegStatusF1CloudString,
  TripLegStatus,
} from '../data/models/trip-leg-status.model';

class TripLegReservationService {
  private readonly apiBase;
  private readonly apiTripBase;

  constructor() {
    const { __environment__ } = window as any;
    this.apiBase =
      __environment__.REACT_APP_TRIP_LEG_RESERVATION_API_URL.trim();
    this.apiTripBase = __environment__.REACT_APP_TRIP_API_URL.trim();
  }

  public updateTripLegDriverAction(
    status: TripLegStatusBC,
    passengerUUID: string,
    tripLegReferenceID: string,
    tripLegStatusDateTimeUTC: string,
  ): Observable<TripLegPackage> {
    const url = `${this.apiBase}/reservations/driverAction`;
    const enumKey = (status.charAt(0).toUpperCase() +
      status.slice(1).toLowerCase()) as keyof typeof TripLegStatusF1CloudString;
    const f1CloudStatus = TripLegStatusF1CloudString[enumKey];
    return httpService.postJSON(url, {
      action: f1CloudStatus,
      passengerUUID,
      tripLegReferenceID,
      tripLegStatusDateTimeUTC,
    });
  }

  public updateTripLegLog(
    status: TripLegStatusBC,
    passengerUUID: string,
    tripLegReferenceID: string,
    tripLegStatusDateTimeUTC: string,
  ): Observable<TripLegPackage> {
    const url = `${this.apiBase}/reservations/updateTripLegLog`;
    return httpService.postJSON(url, {
      status: status.toLowerCase(),
      passengerUUID,
      tripLegReferenceID,
      tripLegStatusDateTimeUTC,
    });
  }

  public overrideTripLegStatus(
    passengerUUID: string,
    tripLegReferenceID: string,
    status: TripLegStatus,
    tripLegStatusDateTimeUTC: string,
    tripLegStatusReasonBCs?: string[] | null,
  ): Observable<TripLegPackage> {
    const url = `${this.apiBase}/reservations/overrideTripLegStatus`;
    return httpService.postJSON(url, {
      passengerUUID,
      tripLegReferenceID,
      status,
      tripLegStatusDateTimeUTC,
      tripLegStatusReasonBCs,
    });
  }
}

const tripLegReservationService = new TripLegReservationService();

export default tripLegReservationService;
